



























































































import { Component, Prop, Watch } from 'vue-property-decorator';

import Modal from '@/components/Modal.vue';
import Vue from 'vue';
import TimeRegistrations from '@/components/TimeRegistrations.vue';
import RegistrationFarmAndVehicleForm from '@/components/RegistrationFarmAndVehicleForm.vue';
import { Ticket } from '@/core/interfaces/ticket';
import { Notification } from '@/core/interfaces/notification';
import TimeRegistrationForm from '@/components/TimeRegistrationForm.vue';
import axios from 'axios';
import { TimeRegistration } from '@/core/interfaces/timeRegistration';
import { Getter } from 'vuex-class';
import { Vehicle } from '@/core/interfaces/vehicle';
import { Farm } from '@/core/interfaces/farm';
import { formatISO } from 'date-fns';

@Component({
    components: {
        TimeRegistrationForm,
        RegistrationFarmAndVehicleForm,
        TimeRegistrations,
        Modal,
    },
})
export default class TimeRegistrationModal extends Vue {
    @Prop({ type: Object, default: null })
    timeRegistration!: TimeRegistration | null;

    @Prop({ type: Object, default: null })
    from!: { ticket: Ticket; notification: Notification } | null;

    @Prop({ type: Boolean })
    locked!: boolean;

    @Getter('vehicleById')
    vehicleById!: (id: number) => Vehicle;

    @Getter('farmById')
    farmById!: (id: number) => Farm;

    type: 'internal' | 'customer' = 'customer';
    farmId: number | null = null;
    vehicleId: number | null = null;
    noTicketOrNotification = false;
    ticketId: number | null = null;
    notificationId: number | null = null;
    description = '';
    startedAt = '';
    timeSpentInMinutes = 10;
    notification: Notification | null = null;
    ticket: Ticket | null = null;

    mounted(): void {
        this.setInitial();
    }

    setInitial(): void {
        if (this.timeRegistration) {
            this.type = this.timeRegistration.type;
            this.startedAt = this.timeRegistration.started_at;
            this.timeSpentInMinutes =
                this.timeRegistration.time_spent_in_minutes;
            this.vehicleId = this.timeRegistration.vehicle_id;
            this.ticketId = this.timeRegistration.ticket_id;
            this.notificationId = this.timeRegistration.notification_id;
            this.description = this.timeRegistration.internal_work_description || '';
            this.noTicketOrNotification = !this.timeRegistration.ticket_id && !this.timeRegistration.notification_id;

            if (this.timeRegistration.vehicle_id) {
                const vehicle = this.vehicleById(
                    this.timeRegistration.vehicle_id,
                );

                this.farmId = vehicle.farm_id;
            }
        } else {
            this.startedAt = formatISO(new Date());

            if (!this.from) {
                this.type = 'internal';
                return;
            }

            this.farmId =
                this.from.ticket?.farm_id ?? this.from.notification?.farm_id ?? null;
            this.vehicleId =
                this.from.notification?.vehicle_id ??
                this.from.ticket?.vehicle_id ??
                null;
            this.notificationId = this.from.notification?.id ?? null;
            this.ticketId = this.from.ticket?.id ?? null;
        }
    }

    async saveRegistration(): Promise<void> {
        if (this.type === 'customer' && !this.noTicketOrNotification) {
            this.$emit('close');

            return;
        }

        const data = {
            type: this.type,
            internal_work_description:
                this.type === 'internal' ? this.description : undefined,
            vehicle_id: this.vehicleId,
            started_at: this.startedAt,
            time_spent_in_minutes: this.timeSpentInMinutes,
        } as Partial<TimeRegistration>;

        if (this.timeRegistration) {
            await axios.put(
                `/time-registrations/${this.timeRegistration.id}`,
                data,
            );
        } else {
            await axios.post('/time-registrations', data);
        }

        this.$emit('close');
    }

    @Watch('ticketId', { immediate: true })
    async fetchTicket(): Promise<void> {
        if (this.ticketId) {
            this.ticket = await axios
                .get<Ticket>(`/tickets/${this.ticketId}`)
                .then((response) => response.data);
        } else {
            this.ticket = null;
        }
    }

    @Watch('notificationId', { immediate: true })
    async fetchNotification(): Promise<void> {
        if (this.notificationId) {
            this.notification = await axios
                .get<Notification>(`/notifications/${this.notificationId}`)
                .then((response) => response.data);
        } else {
            this.notification = null;
        }
    }

    get saveBtnDisabled(): boolean {
        if (this.type === 'internal') {
            return false;
        } else {
            if (!this.vehicleId) {
                return true;
            } else {
                if (this.noTicketOrNotification) {
                    return false;
                } else {
                    return !this.ticketId && !this.notificationId;
                }
            }
        }
    }

    get showCancelBtn(): boolean {
        if (this.type === 'internal' || this.noTicketOrNotification) {
            return true;
        } else {
            return false;
        }
    }

    get saveBtnCaption(): string {
        if (this.type === 'internal' || this.noTicketOrNotification) {
            return 'Save';
        } else {
            return 'Close';
        }
    }
}
